class AuxRoutines {

	static getLocationName($base, $company, $backendUrl = null) {
		let returnValue = 'Grupo Santa';
		if ($base === 'db-orcl-hsl') {
			if ($company === 1) returnValue = 'Hospital Santa Lúcia Sul';
			if ($company === 4) returnValue = 'Hospital Santa Lúcia Norte';
			if ($company === 9) returnValue = 'Unidade Avançada Taguatinga';
			if ($company === 11) returnValue = 'Ânima Centro Hospitalar';
		}
		if ($base === 'db-orcl-hsln') {
			returnValue = 'Hospital Santa Lúcia Norte';
		}
		if ($base === 'db-orcl-hma') {
			returnValue = 'Hospital Santa Lúcia Gama';
		}
		if ($base === 'db-orcl-hsr') {
			if ($company === 1) returnValue = 'Hospital Santa Rosa';
			if ($company === 10) returnValue = 'Hospital Ortopédico';
			if ($company === 11) returnValue = 'Unidade Avançada Várzea Grande';
		}
		if ($base === 'db-orcl-crb') {
			returnValue = 'Centro Radiológico de Brasília';
		}
		if ($base === 'db-orcl-crg') {
			returnValue = 'Centro Radiológico do Gama';
		}
		if ($base === 'db-orcl-igesp' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('igesp'))) {
			returnValue = 'IGESP';
		}
		if ($base === 'db-orcl-santacasasjc' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('santacasasjc'))) {
			returnValue = 'SCSJC';
		}
		if ($base === 'db-orcl-hshgo' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('hsh'))) {
			returnValue = 'HSH';
		}
		if ($base === 'db-orcl-amaralcarvalho' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('amaralcarvalho'))) {
			returnValue = 'Amaral Carvalho';
		}
		if ($base === 'db-orcl-aebel' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('aebel'))) {
			returnValue = 'AEBEL';
		}
		if ($base === 'db-orcl-humanamagna' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('humanamagna'))) {
			returnValue = 'Humana Magna';
		}
		return returnValue;
	}
}
export default AuxRoutines;